<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n2I5e5/tc-custom/9781466834798.jpg?1732053253477" alt="This image is the cover for the book I'll Tell Them I Remember You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I'll Tell Them I Remember You
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>I'll Tell Them I Remember You</i> is <i>New York Times</i> bestselling author William Peter Blatty's memoir about being raised by his single Lebanese mother struggling to make ends meet in 1930s Manhattan.</b><br/><br/>In this heartfelt and humorous autobiography, Blatty shares what it was like growing up with a strong-willed and opinionated mother who did anything and everything to keep her five children fed and sheltered no matter how strange or unusual. Her spirit and influence helped shape Blatty as a man, a father, and as the famous author of <i>The Exoricst</i>.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Peter Blatty
      </h2>
      
      <p class="authorDescription body article"><B>William Peter Blatty (1928-2017)</B>, the writer of numerous novels and screenplays, is best known for his mega-bestselling novel <I>The Exorcist</I>, deemed by the <I>New York Times Book Review</I> to be "as superior to most books of its kind as an Einstein equation is to an accountant's column of figures." An Academy Award winner for his screenplay for <I>The Exorcist</I>, Blatty is not only the author of one of the most terrifying novels ever written, but, paradoxically, also cowrote the screenplay for the hilarious Inspector Clouseau film, <I>A Shot in the Dark. New York Times</I> reviewers of his early comic novels noted, "Nobody can write funnier lines than William Peter Blatty," describing him as "a gifted virtuoso who writes like S. J. Perelman."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93a95022